/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from '@bfe/moly';
import React, { FC, useEffect, useMemo, useState } from 'react';

import AccountBasicItem from '@/components/AccountBasicItem';
import { useI18nContext } from '@/i18n/I18n';
import { getUserTag } from '@/services/user';

const Resident = {
  AUT: 'AUT',
  'P-AUT': 'P-AUT',
};

const TaxJurisdiction: FC = () => {
  const [$t] = useI18nContext();

  const [resident, setResident] = useState('');
  const [visible, setVisible] = useState(false);

  const status = useMemo(() => {
    return Object.keys(Resident).includes(resident as keyof typeof Resident);
  }, [resident]);

  const fetchTaxResident = () => {
    getUserTag(['tax_resident']).then((res) => {
      const status = res?.result?.user_tags?.tax_resident;
      setResident(status);
    });
  };

  useEffect(() => {
    fetchTaxResident();
  }, []);

  const openAMP = () => {
    window?.BybitUniFrame?.ready(async ({ AMPDialog }: { AMPDialog: any }) => {
      // 初始化组件
      await AMPDialog?.init?.();

      AMPDialog?.setProperty?.(AMPDialog?.properties?.VISIBLE, true)
        ?.setProperty?.(AMPDialog?.properties?.THEME, 'theme-light')
        ?.setProperty?.(AMPDialog?.properties?.FROM, 'us_AUT')
        ?.setProperty?.(AMPDialog?.properties?.PRODUCT_ID, '100005');

      // 监听取消
      AMPDialog?.subscribeEvent(AMPDialog?.events?.HIDE_MODAL, () => {
        setVisible(false);
        AMPDialog?.dealloc?.(); // 问卷使用场景不多，所以关闭就直接销毁
      });

      // 监听完成
      await AMPDialog?.subscribeEvent(AMPDialog?.events?.SUCCESS, () => {
        setVisible(false);
        AMPDialog?.dealloc?.(); // 问卷使用场景不多，所以完成后就直接销毁
        fetchTaxResident();
      });
    });
  };

  const handleSetting = () => {
    openAMP();
  };

  const handleChange = () => {
    openAMP();
  };

  return (
    <>
      <AccountBasicItem
        icon="kyc"
        text={$t('TaxJurisdiction')}
        subText={$t('TaxJurisdictionDesc')}
        status={
          Resident[resident as keyof typeof Resident] ? status : undefined
        }
        statusNode={
          Resident[resident as keyof typeof Resident] ? (
            <> {$t(Resident[resident as keyof typeof Resident])}</>
          ) : (
            <></>
          )
        }
        operation={
          <Button
            size="small"
            data-radius="small"
            variant={status ? 'secondary' : 'primary'}
            onClick={() => {
              if (status) {
                handleChange();
              } else {
                handleSetting();
              }
            }}
          >
            {status ? $t('Change') : $t('Set up')}
          </Button>
        }
      />
    </>
  );
};
export default TaxJurisdiction;
